import styles from './MySchedule.module.css';
import { MapPin, Users, Calendar, Clock } from 'lucide-react';
import WidgetTile from '../WidgetTile';
import { ScheduleEvent } from '../../../types';

interface ScheduleItemProps {
  title: string;
  location: string;
  confirmed: number;
  date: string;
}

const ScheduleItem = ({ title, location, confirmed, date }: ScheduleItemProps) => {
  const eventDate = new Date(date);
  const time = eventDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const day = eventDate.toLocaleDateString([], { weekday: 'long' });

  return (
    <WidgetTile title={title}>
      <div className={styles.meta}>
        <span><Calendar size={12} aria-hidden="true" /> {day}</span>
        <span><Clock size={12} aria-hidden="true" /> {time}</span>
      </div>
      <div className={styles.meta}>
        <span><MapPin size={12} aria-hidden="true" /> {location}</span>
        <span><Users size={12} aria-hidden="true" /> {confirmed} confirmed</span>
      </div>
    </WidgetTile>
  );
};

interface MyScheduleProps {
  events: ScheduleEvent[];
}

const MySchedule = ({ events }: MyScheduleProps) => {
  return (
    <ul className={styles.scheduleList} role="list" aria-label="My schedule">
      {events.map(event => (
        <li key={event.id}>
          <ScheduleItem {...event} />
        </li>
      ))}
    </ul>
  );
};

export default MySchedule;
